import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { ExpenseTypeService } from '../../../services/index';

@Component({
    selector: 'add-edit-expense-type',
    templateUrl: './addEditExpenseType.component.html'
})
export class AddEditExpenseTypeComponent implements OnInit {

    @Output() expenseTypeLoadEvent = new EventEmitter();

    public title: string;
    public expenseTypeData: any = {};
    public isLoading: boolean = false;

    statusOptions = ['Active', 'Inactive'];

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private expenseTypeService: ExpenseTypeService
    ) { }

    ngOnInit(): void {
        if (this.expenseTypeData.mode === 'Add') {
            this.expenseTypeData.status = 'Active';
        }
    }

    onSave(): void {
        this.isLoading = true;

        let params = {
            mode: this.expenseTypeData.mode,
            name: this.expenseTypeData.name,
            status: this.expenseTypeData.status
        };

        if (this.expenseTypeData.mode === 'Edit') {
            params['id'] = this.expenseTypeData.id;
        }

        this.expenseTypeService
            .addUpdateExpenseType(params)
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.success) {
                    this.toasterService.pop({
                        type: 'success',
                        title: 'Success',
                        body: res.message
                    });
                    this.expenseTypeLoadEvent.emit();
                    this.bsModalRef.hide();
                } else {
                    this.toasterService.pop({
                        type: 'error',
                        title: 'Error',
                        body: res.message || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                this.isLoading = false;
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'Something went wrong'
                });
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/expenseType/addEditExpenseType.component.ts